import type { UnifiedCardStackAttributes } from "@shared/models/card-stack"
import { emptyCardStackExtracted } from "./extracted"

/** A phantom lesson before any template lands on it: unified schema, no content. */
export function blankUnifiedLessonAttributes(): UnifiedCardStackAttributes {
  return {
    title: null,
    color: null,
    parentCardStack: null,
    version: 0,
    versionNarrative: {},
    _revision: 0,
    _revisedBySessionId: null,
    schemaVersion: 2,
    usedAs: "lesson",
    commentIds: [],
    proseMirror: null,
    extracted: emptyCardStackExtracted(),
    cards: null,
  }
}
